import { Box } from '@auviknetworks/iceberg-ui';
import React from 'react';

/*  Components  */
import { CategoryOverview } from './Components/CategoryOverview';
import { CategoryUsageBreakdown } from './Components/CategoryUsageBreakdown';
import { ApplicationOverlapReportData } from './types';

export interface ApplicationOverlapReportProps {
    reportData: ApplicationOverlapReportData;
    renderingScheduledReport: boolean;
}

export const ApplicationOverlapReport = ({
    reportData,
    renderingScheduledReport
}: ApplicationOverlapReportProps) => (
    <>
        {reportData?.applicationOverlapApplicationOverlapCategoryOverview && (
            <Box id="applicationOverlapApplicationOverlapCategoryOverview">
                <CategoryOverview
                    renderingScheduledReport={renderingScheduledReport}
                    categoryData={
                        reportData.applicationOverlapApplicationOverlapCategoryOverview
                    }
                />
            </Box>
        )}

        {reportData?.applicationOverlapApplicationOverlapCategoryBreakdown && (
            <Box id="applicationOverlapApplicationOverlapCategoryBreakdown">
                <CategoryUsageBreakdown
                    categoryUsageBreakdownData={
                        reportData.applicationOverlapApplicationOverlapCategoryBreakdown
                    }
                />
            </Box>
        )}
    </>
);
